import { Component, Input, OnChanges, SimpleChanges, ViewEncapsulation, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { Product } from '../../models/product.model';
import { Sale } from '../../models/sale.model';
import { ProductOption, Hour } from '../../models/product-option.model';
import { ProductService } from '../../services/product.service';
import { Cookie } from '../../shared/cookie.service';
import { HeaderService } from '../../shared/header.service';
import { CurrencyService } from '../../shared/currency.service';
import { AnalyticsUtilsService } from '../../shared/analytics-utils.service';
import { AppSettings } from '../../settings/app.settings';
import { NominativeVouchers } from '../../models/nominative-voucher.model';

@Component({
  selector: 'product-options',
  templateUrl: './options.component.html',
  styleUrls: ['./options.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class ProductOptionsComponent implements OnChanges{
  public isNode:Boolean;
  public totalPeople:number = 0;
  public available:number = 0;
  public buttonDisable: boolean = false;
  public filter:any = {};
  public availableDetails={"DURATION":[],"VEHICLE":[],"VIP":false};   //This variable help us to control html elements
  public messageError:boolean = false;
  public listDuration:any[] = [];
  public listVehicles:any[] = [];
  public errorSelectTime:boolean = false;
  public selectTime:any;
  public actualCurrency:number;
  private selectedOption:ProductOption;
  public nominativeVouchers: NominativeVouchers[];
  public unitPersonsNominativeVoucher = [];
  public stepFormNominative: number = 0;
  public hideButtonNextStep: boolean;
  public optionsNominativeVouchers: any[] = [];
  public formInvalid: boolean;
  public isNotBookable: boolean = false;
  @Input() product:Product;
  @Input() options:ProductOption[] = [];

  constructor(private productService:ProductService, private cookie:Cookie, private headerService:HeaderService, 
    public currencyService:CurrencyService, private router:Router, private translate:TranslateService,
    private analyticUtils:AnalyticsUtilsService, @Inject(PLATFORM_ID) private platformId:Object){
      this.isNode = isPlatformServer(this.platformId);
    }

  ngOnChanges(changes:SimpleChanges){
    if(this.options){
      this.selectTime = 'none';
      this.optionsNominativeVouchers = [];
      this.options = this.options.map((option,index) => {
        option = Object.assign(new ProductOption, option);
        if(option.groupedOption){
          this.availableDetails.DURATION = option.durationsAvailables.map(p=>{
            return {originalDuration: p.originalDuration};
          });
          this.availableDetails.VEHICLE = option.vehiclesAvailable.map(p=>{
            return {vehicleName: p.vehicleName};
          });
          this.listDuration = [];
          this.listVehicles = [];

          this.listOfDuration(option.durationsAvailables);
          this.listOfVehicles(option.vehiclesAvailable);

          option.groupedOptionList.forEach(group => {
            this.optionsNominativeVouchers.push({id: group.id, nominativeVoucher: group.nominativeVoucher})
          }); 
        }else{
          option['isnotGrouped'] = true;
          option.groupedOption = true; //WTF
          option.groupedOptionList = [option];

          this.optionsNominativeVouchers.push({id: option.id, nominativeVoucher: option.nominativeVoucher});
        }
        
        this.setImage(option);
        this.calculeHighPrice(option);
        this.updateFilter(option,option.groupedOptionList[0]);
        this.filterOption(option,null)
        this.setHours(option);
        
        if(index==0){
          option.active = true;
        }
        return option;
      });
      if(this.options.length > 0){
        this.getActualCurrency(this.currencyService.currencyStr);
        this.openOption(this.options[0]);
        this.stepFormNominative = 0;
        this.hideButtonNextStep = false;
        this.formInvalid = true;
      }
    }
  }

  listOfDuration(durations){
    durations.map(duration => {
      this.listDuration.push(duration);
    });
  }

  listOfVehicles(vehicles){
    vehicles.map(vehicle => {
      this.listVehicles.push(vehicle);
    });
  }

  /**
   * Method to control attr named data-active to hide/show options
   * @param option Option selected
   */
  isActive(option:ProductOption):boolean{
    return option['active'] == true;
  }

  /**
   * Set active to false in all options to close and set true to select open option
   * @param option Option selected
   */
  openOption(option):void{
    this.listDuration = [];
    this.listVehicles = [];
    this.unitPersonsNominativeVoucher = [];

    if (option) {
      if (option.active === false){
        this.selectTime = 'none';
      }
      this.errorSelectTime = false;
      this.listOfDuration(option.durationsAvailables);
      this.listOfVehicles(option.vehiclesAvailable);
      this.options.forEach(opt => {
        opt['active'] = false;
        opt['cutofferror'] = '';
      });
      option['active'] = true;

      this.optionsNominativeVouchers.map(opt => {
        if (option.id === opt.id) {
          option['nominativeVoucher'] = opt.nominativeVoucher;

          if (!option['nominativeVoucher']) {
            this.formInvalid = false;
          } else {
            option.units.forEach(unit => {
              for (let i = 0; i < unit.pax; i++) {
                this.unitPersonsNominativeVoucher.push({person: unit.personType, number: i + 1});
              }
            });
          }
        }
      });
      if (option !== this.selectedOption) {
        this.selectedOption = option;
        this.stepFormNominative = 0;
        this.hideButtonNextStep = false;
      }
    }
  }

  /**
   * Add new group of people to option
   * @param option option selected
   */
  addNewGroup(option){
    let hour = option.hours.filter(hour => {return hour.id == option.selectedHour.id})[0];
    if(hour.quota == undefined || option.groups.length < hour.quota){
      option.groups.push({pax:0, amount:0});
    }
  }

  /**
   * Set the small image to option property
   * @param option Option or options
   */
  setImage(option){
    option.smallImage = this.optionImage(option);
  }

  /**
   * Set the options hours to hoursPrepared property
   * @param option option
   */
  setHours(option){
    option.hoursPrepared = this.hoursPrepared(option);
  }

  /**
   * Add to cart, create new Sale  
   * @param option Option to add
   */
  addToCart(event,option) {
    this.buttonDisable = true;
    if(this.selectTime == 'none' && option.hoursPrepared.length >= 4){
      this.translate.get("DURATION_ERROR").subscribe(res => {
        option['cutofferror']= res;
      });
      this.buttonDisable = false;
      this.errorSelectTime = true;
    } else {
      if (!option.selectedHour) {
        option.selectedHour = option.hoursPrepared[0];
      }
      const sale: Sale = new Sale();
      
      const productOption = new ProductOption();
      productOption.id = option.id;
      
      sale.date = option.date;
      if (option.date != null) {
        const day = option.date.getDate();
        const month = option.date.getMonth() + 1;
        const year = option.date.getFullYear();
        sale.dateStr = year + '-' + month + '-' + day;
      }
      sale.productOption = productOption;
      if (!option.isGroup) {
        sale.units = option.units;
      } else {
        let units = option.groups.map(group => {
          return { amount: group.amount, pax: group.pax, personType: { id: 1 } }
        });
        units = units.filter(unit => {
          return unit.pax !== 0;
        });
        sale.units = units;
      }
      sale.openTime = option.selectedHour;
      
      sale['deviceId'] = this.getDevice();
      sale.nominativeVouchers = this.nominativeVouchers;

      this.productService.addToCart(sale).subscribe(message => {
        if (message.response.updated === true) {
          this.cookie.put('guest_session', message.token);
          this.cookie.put('guest_cart_element', message.response.numberOfSales);
          this.headerService.numElementsCart = parseInt(message.response.numberOfSales);
          this.analyticUtils.eCommerce_addToCart(this.product, option, this.currencyService.currencyStr);
          this.translate.get('BASKET_URL').subscribe(basket => {
            this.router.navigate([`/${this.translate.currentLang}/${basket}`]);
          });
        } else if (message.token == null) {
          this.cookie.remove('guest_session');
          this.cookie.put('guest_cart_element', '0');
        }
        if (message.response.errorMessage) {
          if(message.response.errorMessage[0] === 'Not bookable independently') {
            this.isNotBookable = true;
          } else {
            let durationType = AppSettings.durationType[message.response.durationType];
            this.translate.get(durationType).subscribe(durationType => {
              this.translate.get("CUTOFF_ERROR", { duration: message.response.duration, durationType: durationType })
              .subscribe(value => {
                option['cutofferror'] = value;
              });
            });
          }
          this.buttonDisable = false;
        }
      });
    }
    event.stopPropagation();
    setTimeout(() => {
      this.errorSelectTime = false;
    }, 1000);
  }

  /**
   * Calcule total of people for options grouped
   * @param group group of options property
   * @param option option selected
   */
  calculeTotal(group,option){
    let __total = 0;
    let pax = group.pax;

    let scale = option.scaledPricing.find(scale => {
      return scale.minNumPeople <= pax && scale.maxNumPeople >= pax
    });
    
    group.amount = (scale != null)?scale.rateAmount:0;
    option.groups.map(e => {
      __total += e.amount || 0;
    });
    option.total = __total;
  }

  /**
   * Calcule max of people for options grouped
   * @param group group of options property
   * @param option option selected
   */
  calculeMax(group,option){
    let pax = group.pax;

    let maxValue = option.scaledPricing.sort(function(a,b){
      return a.maxNumPeople < b.maxNumPeople
    })[0].maxNumPeople;

    this.available = this.totalPeople;
    option.groups.map(__group => {
      this.available = this.available - __group.pax;
    });
    let min = Math.min(maxValue, this.available);
    return Math.min(maxValue, min+pax);
  }

  /**
   * Click to change duration div 
   * @param option Option selected
   * @param duration The new object duration, properties duration, durationName, originalDuration
   */
  checkDuration(option:ProductOption,duration){
    if(option.filter.duration.originalDuration != duration.originalDuration){
      option.filter.duration = duration;
      this.filterOption(option,"DURATION");
      this.analyticUtils.click_on_option_property('DURATION');
      this.stepFormNominative = 0;
      this.hideButtonNextStep = false;
    }
  }

  /**
   * Click to change vehicle div
   * @param option Option selected
   * @param vehicle Object vehicle, option.vehiclesAvailable array property
   */
  checkVehicle(option,vehicle){
    if(option.filter.vehicle.vehicleName != vehicle.vehicleName){
      option.filter.vehicle = vehicle;
      this.filterOption(option,"VEHICLE");
      this.analyticUtils.click_on_option_property('VEHICLE');
      this.stepFormNominative = 0;
      this.hideButtonNextStep = false;
    }
  }

  /**
   * Click to change hour div
   * @param option Option selected
   * @param hour Object hour, option.hoursPrepared array property with id,name and selected
   */
  checkHour(option,hour){
      option.hoursPrepared.map(ele => {
        ele.selected = false;
        if(ele.name == hour.name){
          ele.selected = true;
          option.selectedHour = hour;
        }
      });
  }

  /**
   * 
   * @param hour object from select
   * @param option option selected
   */
  selectChangeTime(hour,option){
    if(this.selectTime != 'none'){
      option.cutofferror = "";
      this.checkHour(option,this.selectTime);
    }
  }

  /**
   * Check if option is vip
   * @param option Option selected
   */
  toggleVip(option){
    option.filter.vip = !option.filter.vip;
    this.filterOption(option,"VIP");
    this.analyticUtils.click_on_option_property('VIP');
  }

  // togglePrice(option){
  //   option.priceOnPhone = !option.priceOnPhone;
  // }

  /**
   * Conflic zone, why this method was evaluated in html component (duration and vehicle) to add css class not-selected if didnt need it
   * @param array availableDetails type elements
   * @param element optionSelectable property
   */
  checkIfIsIncluded(array,element){
    return array.some(_e => {
      for(let attr in _e){
        if(_e[attr] == element[attr]){
          return true;
        }
      }
      return false;
    })
  }

  /*
  PRIVATE METHODS
  */

 /**
  * First create a new array of option with the conditions, check if the option selectable has
  * the correct option filter properties ,find it and merge the changes
  * @param option Option Selected
  * @param type Type of the option with changes, every toggle of the option box execute this function
  */
  private filterOption(option:ProductOption,type:string){
    let optionSelectable = option.groupedOptionList.filter(group => {
      let durationFilter:boolean = true;
      let vehicleFilter:boolean = true;
      let vipFilter:boolean = true;
      if(type == "DURATION"){
        durationFilter = (group.duration == parseInt(option.filter.duration.originalDuration)); 
      }
      if(type == "VEHICLE"){
        vehicleFilter = (group.vehicleName == option.filter.vehicle.vehicleName);
      }
      if(type == "VIP"){
        vipFilter = (group.vip == option.filter.vip);
      }

      return durationFilter && vehicleFilter && vipFilter;
    });

    //variable to verify if the option selectable has the correct option.filter
    let someIsCorrectlyFiltered = this.findOptionFiltered(optionSelectable, option.filter);
    if(!someIsCorrectlyFiltered){
      //If not, set the option.filter properties again
      this.updateFilter(option,optionSelectable[0])
    }

    if(type != "DURATION"){
      this.availableDetails.DURATION = [];
      optionSelectable.map(opt => {
        if(!this.checkIfIsIncluded(this.availableDetails.DURATION,{originalDuration: opt.duration})){
          this.availableDetails.DURATION.push({originalDuration: opt.duration});
        }
      });
    }
    if(type != "VEHICLE"){
      this.availableDetails.VEHICLE = [];
      optionSelectable.map(opt => {
        if(!this.checkIfIsIncluded(this.availableDetails.VEHICLE,{vehicleName: opt.vehicleName})){
          this.availableDetails.VEHICLE.push({vehicleName: opt.vehicleName});
        }
      });
    }
    if(type != "VIP"){
      this.availableDetails.VIP = false;
      optionSelectable.map(opt=>{
        this.availableDetails.VIP =  this.availableDetails.VIP || opt.vip;
      });
    }
    if(type == "DURATION"){
      this.availableDetails.DURATION = option.durationsAvailables.map(p=>{
        return {originalDuration: p.originalDuration};
      });
    }
    if(type == "VEHICLE"){
      this.availableDetails.VEHICLE = option.vehiclesAvailable.map(p=>{
        return {vehicleName: p.vehicleName};
      });
    }
    if(type == "VIP"){
      this.availableDetails.VIP = option.vipAvailable;
    }

    let optionMatched = this.findOptionFiltered(option.groupedOptionList, option.filter);
    this.mergeOptionFiltered(option, optionMatched);
  }

  /**
   * Calculate the promotion price for the option
   * @param option First option
   */
  private calculeHighPrice(option:ProductOption){
    if(option.promotion)
      option.highPrice = (option.total * 100)/(100 - option.promotion["value"]);
  }

  /**
   * The price is recalculated when you change from one option to another in grouped form
   * @param src The new option in grouped
   */
  private calculeHighPriceSingle(src){
      return (src.total * 100)/(100 - src.promotion["value"]);
  }

  /**
   * Merge the properties to the new option selected
   * @param target option that is selected
   * @param src option to be selected
   */
  private mergeOptionFiltered(target:ProductOption, src:ProductOption){
    target.total = src.total;
    target.units = src.units;
    target.hours = src.hours;
    target.languageGuide = src.languageGuide;
    target.languageLive = src.languageLive;
    target.mobileAccess = src.mobileAccess;
    target.freeCancellation = src.freeCancellation;
    target.checkWheelChair = src.checkWheelChair;
    target.description = src.description;
    target.id = src.id;    
    target['hoursPrepared'] = this.hoursPrepared(src);
    target.newPrice = false;
    if(src.promotion && src.promotion.promotionType === "RETAIL"){
      target['newPrice'] = true;
      target.promotion = src.promotion;
      target.highPrice = this.calculeHighPriceSingle(src);
    }
  }

  /**
   * Check por actual currency
   * @param currency currency name
   */
  private getActualCurrency(currency){
    if(currency === "EUR"){
      this.actualCurrency = 1;
    } else if(currency === "GBP"){
      this.actualCurrency = 2;
    } else {
      this.actualCurrency = 3;
    }
  }

  /**
   * Set the properties of the first productOption to selectable option by default
   * @param option The parent object with an array of productOptions
   * @param selectable The first productOption in the array (Maybe change)
   */
  private updateFilter(option:ProductOption, selectable:ProductOption){
    if(selectable == null){
      selectable = option;
    }
    option.filter.duration = {originalDuration: selectable.duration};
    option.filter.vehicle = {vehicleName: selectable.vehicleName};
    option.filter.vip = selectable.vip;
  }

  /**
   * Try to find if the option changed has the correct filter properties
   * @param options Option to change
   * @param filter This is a property of option
   */
  private findOptionFiltered(options:ProductOption[], filter:any){
    return options.find(o => {
      return (o.duration == parseInt(filter.duration.originalDuration)) &&
      (o.vehicleName == filter.vehicle.vehicleName) &&
      (o.vip == filter.vip);
    })
  }

  /** 
   * Get the device for sale object
  */
  private getDevice(){
    if (navigator.userAgent.match(/Tablet|iPad/i)){
        return AppSettings.DEVICE_TABLET;
    } else if(navigator.userAgent.match(/Mobile|Windows Phone|Lumia|Android|webOS|iPhone|iPod|Blackberry|PlayBook|BB10|Opera Mini|\bCrMo\/|Opera Mobi/i) ) {
        return AppSettings.DEVICE_MOBILE;
    } else {
        return AppSettings.DEVICE_DESKTOP;
    }
  }

  /**
   * Return small image resize
   * @param option option or options
   */
  private optionImage(option) {
    return (option.smallImage)?`${AppSettings.OPTION_IMAGES}${option.smallImage}`:null;
  }

  /**
   * Create object selectedHour
   * @param option select option
   */
  private hoursPrepared(option){
    let hours =  option.hours.map((h:Hour, index:number) => {
        if(!option.selectedHour)
            return {id:h.id, name: `${h.initTime}${h.endTime?'-'+h.endTime:''}`, selected: index==0}
        else
            return {id:h.id, name: `${h.initTime}${h.endTime?'-'+h.endTime:''}`, selected: h.id == option.selectedHour.id}            
    });

    let someSelected = hours.find(h => {
        return h.selected == true;
    });
    if(!someSelected){
        hours.forEach((h,i)=>{
            if(i==0){h.selected = true}
        });
    }
    return hours;
  }

  nextStepVoucherNominative(event) {
    this.stepFormNominative++;
    event.stopPropagation();
    this.checkStepFormNominative();
    this.formInvalid = true;
  }

  backStepVoucherNominative(event) {
    this.stepFormNominative--;
    event.stopPropagation();
    this.checkStepFormNominative();
    this.formInvalid = false;
  }

  validNominativeVoucher(items) {
    if (items.valid) {
      this.nominativeVouchers = items.value;
      this.formInvalid = false;
    } else {
      const itemFormNominativeVoucher = items['controls'][this.stepFormNominative - 1];
      if (itemFormNominativeVoucher.valid) {
        this.formInvalid = false;
      } else {
        this.formInvalid = true;
      }
    }
  }

  checkStepFormNominative() {
    if (this.stepFormNominative >= this.unitPersonsNominativeVoucher.length) {
      this.hideButtonNextStep = true;
    } else {
      this.hideButtonNextStep = false;
    }
  }

}